import React from 'react'
import { Row, Col, Form, Button, Modal, InputGroup } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import CommonSelectTable from './CommonSelectTable';
import { useState, useEffect } from "react";
import vector from '../../assets/setup-icon/Vector.png';
import _ from "lodash";
import { DebounceInput } from 'react-debounce-input';
import * as types from "../../constants/ActionTypes";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../shared/Toast";
import Pagination from "../shared/ReactPaginate";
import DragShimmer from './shimmer/DragShimmer';
import { searchInput, fetchPartnerCategoryListing, addPartnerCategory, deletePartnerCategory } from "../../redux/actions/setupActions";

const SetupParentCatgeory = (props) => {
    // let navigate = useNavigate();
    const dispatch = useDispatch();
    // const isLoading = useSelector((state) => state.setupScreen.loading);
    let isLoading = useSelector((state) => state.setupScreen.loading);
    let search_input = useSelector((state) => state.setupScreen.search_input);
    let pageNum = useSelector((state) => state.setupScreen.currPage);
    const authToken = props.authToken;
    const total_data = useSelector((state) => state.setupScreen.parent_category_list?.total_data);
    const parent_list = useSelector((state) => state.setupScreen.parent_category_list);
    const [checked, setChecked] = useState(0);
    const [tableContent, setTableContent] = useState({});
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [sortValue, setSortValue] = useState("ASC");
    const [contentList, setContentList] = useState({});
    const [showDelete, setShowDelete] = useState(false);
    const [radioBtn, setRadioBtn] = useState({ Language: ""});
    const [categoryName, setCategoryName] = useState("");
    const { Language } = radioBtn;

    // console.log(radioBtn,"radioBtn")

    const handleAddPartnerCategory = (authToken,categoryName,Language) => {
      if(categoryName !== "" && Language !== ""){
        dispatch(addPartnerCategory(authToken, categoryName, Language))
        setCategoryName("");
        setRadioBtn({Language: ""});
        setShow(false)
    }else{
      Toast("Please fill all the fields", "E");
    }
  }


    const handleRadioBtn = e => {
      e.persist();
      // console.log(e.target.value);
  
      setRadioBtn(prevState => ({
        ...prevState,
        Language: e.target.value
      }));
    };

  
    const handleCloseDelete = () => setShowDelete(false);
  
    const handleShowPopup = () => {
        setShowDelete(true);
    }
  
    const deleteHandleShow = () => {
      dispatch(deletePartnerCategory(authToken, contentList,pageNum));
      handleCloseDelete();
      setContentList({});
      setChecked(0);
    }

    const handleUnselectedData = (value) => {
      setIsSelectAll(value)
    }
  
    const selectAllHashtag = (selectFlag) => {
      setIsSelectAll(!selectFlag);
      let all_ids = parent_list.data.map((item) => {
        return item.id;
      })
      setChecked(parent_list?.data?.length);
      setContentList({web: all_ids});
    }
    
    const handleRemoveSearch = (e) => {
        setSearchValue("");
        dispatch(searchInput(""));
        dispatch(fetchPartnerCategoryListing(authToken, pageNum, ""));
    }
    const dateSorting = (e) => {
      if (sortValue === "ASC") {
        setSortValue("DESC");
      } else {
        setSortValue("ASC");
      }  
      dispatch(fetchPartnerCategoryListing(authToken, pageNum, search_input, sortValue));
    }
    const handleSearch = (e) => {
      setSearchValue(e.target.value);
      dispatch(searchInput(e.target.value));
      dispatch(fetchPartnerCategoryListing(authToken, 0, e.target.value));
    }
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const handleCheck = (e, id, type) => {
      if (e === null) {
        setChecked(0);
      } else {
        let _updatedContent = _.clone(contentList);
        let count = checked;
        if (e.target.checked) {
          if (_.has(contentList, [type])) {
            if (!_updatedContent[type].includes(id)) {
              _updatedContent[type].push(id);
            }
          } else {
            _updatedContent[type] = [id];
          }
          setChecked(count + 1);
        } else {
          if (_.has(contentList, [type])) {
            _updatedContent[type] = _updatedContent[type].filter(
              (item) => item !== id
            );
            if (_updatedContent[type].length === 0) {
              _updatedContent = _.omit(_updatedContent, [type]);
            }
          }
          setChecked(count - 1);
        }
        setContentList(_updatedContent);
      }
    };
  
    useEffect(() => {
        let tableCont={
            checkbox: { value: true, width: "5%" },
            language: { value: true, width: "20%" },
            title: { value: true, width: "20%" },
            date: { value: true, width: "12%" },
            divider: { value: true, width: "3%" },
            time: { value: true, width: "25%" },
            edit: { value: true, width: "90%" },
        }
        setTableContent(tableCont);
        // setSearchValue(search_input);
        dispatch(fetchPartnerCategoryListing(authToken, pageNum, ""));
    }, []);
  
    useEffect(() => {    // onDestroy
        return () => {
          dispatch({ type: types.SEARCH_INPUT, payload: "" });
          // dispatch({ type: types.CURRENT_PAGE, payload: 0 });
        }
    }, [])
    
    return (
      <div>
        <div>
          <div>
            <InputGroup className="mb-3 search-inside">
              <DebounceInput value={searchValue} className="search-inside-input" placeholder="Search Partner Category" minLength={3} debounceTimeout={2000} onChange={handleSearch} />
              <InputGroup.Text id="basic-addon1">
                {searchValue && searchValue !== "" ? <Icon.X color="#A8A8A8" onClick={handleRemoveSearch} /> : <Icon.Search color="#A8A8A8" onClick={handleSearch}/>}
              </InputGroup.Text>
            </InputGroup>
            <div className='right-buttons'>
              <span>Sort By <span className='sort-text mx-1' onClick={dateSorting}>Date Added <img className={sortValue === "DESC" ? 'rotate' : ''} src={vector} alt="icon" /></span></span>
              <Button style={{marginLeft: '60px'}} onClick={handleShow} className='common-setup-button' variant="primary">+ Add Partner Category</Button>
            </div>
          </div>
          
          {checked > 0 && (
            <Row>
              <Col>
                <div className="selectedAssetActions">
                  <ul>
                    <li>
                      <Button variant="light selected">
                        {checked} Selected
                      </Button>
                    </li>
                      <li>
                        <Button
                          variant="light"
                          onClick={handleShowPopup}
                        >
                          <span>
                            <Icon.Trash />
                          </span>
                          Delete
                        </Button>
                    </li>
                  </ul>
                    <ul className="float-right">
                      <li>
                      <Button
                        variant="light selected"
                        onClick={() => {
                          selectAllHashtag(isSelectAll)
                        }}
                      >
                        Select All
                      </Button>
                      </li>
                      <li>
                        <Button
                          variant="light selected"
                          onClick={() => {
                            setContentList({});
                            setChecked(0);
                            setIsSelectAll(false);
                          }}
                        >
                          Unselect
                        </Button>
                      </li>
                    </ul>
                </div>
              </Col>
            </Row>
          )}
          
            <Row>
              <Col>
                <div className="top-heading-bar">
                  <ul>
                    <li style={{width: "22%"}}>
                      <span>Category</span>
                    </li>
                    <li style={{width: "20.5%"}}>
                      <span>Language</span>
                    </li>
                    <li style={{width: "12%"}}>
                      <span>Created Date</span>
                    </li>
                    <li style={{float: "right",paddingRight:"10px"}}>
                      <span>Actions</span>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
                
          <div>
            {isLoading && <DragShimmer subPageName={props.subPageName} tableData="partner_category_list"/>}
            { isLoading === false && parent_list?.data.map((listItem,index) => {
              return (
                <Col key={index}>
                      <CommonSelectTable tableData="partner_category_list" authToken={props.authToken} displayContent={tableContent} listItem={listItem} handleCheck={handleCheck} handleUnselectedData={handleUnselectedData} isSelectAll={isSelectAll} checked={checked} />
                </Col>
              )
            })}
            {parent_list?.data === 0 && (
              <div className="no-data asset">
                <span>
                  <Icon.Inbox />
                </span>
                <br />
                No Data
              </div>
            )}
          </div>
          
          {total_data > 20 && <Pagination authToken={props.authToken} total_page={ total_data } page={pageNum} currPage={props.subPageName} />}
          
          {/* reactivate partner popup */}
          <Modal className='partner-category delete-popup' show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Create Partner Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
              <Form.Label>Language : </Form.Label>
              <Form.Check
                inline
                // label="All"
                // type="radio"
                // onChange={(e) => {console.log(e,"events")}}

                value="All"
                type="radio"
                aria-label="radio 1"
                id="inline-radio-1"
                name="group1"
                label="All"
                onChange={handleRadioBtn}
                checked={Language === "All"}
              />
              <Form.Check
                inline
                value="LanguageSpecific"
                type="radio"
                aria-label="radio 2"
                name="group1"
                label="Language Specific"
                onChange={handleRadioBtn}
                checked={Language=== "LanguageSpecific"}
                // label="Language Specific"
                // name="group1"
                // type="radio"
                id="inline-radio-2"
              />
              <Form.Group className="my-3">
                <Form.Control
                  type="email"
                  placeholder="Category Name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={()=>handleAddPartnerCategory(authToken,categoryName,radioBtn?.Language)}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
          
          {/* Delete popup  */}
            <Modal className="delete-popup"  show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={deleteHandleShow}>
                      Delete
                    </Button>
                    <Button variant="secondary" onClick={handleCloseDelete}>
                      Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
          
        </div>
      </div>
    )
}

export default SetupParentCatgeory;